import type { Peer } from "@circle-react/types/Live/Peer";
import { useHMSPeerMediaStatus } from "../hms";
import { useLivekitPeerMediaStatus } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeerMediaStatus = (peer: Peer) =>
  useProviderHook({
    hms: useHMSPeerMediaStatus,
    livekit: useLivekitPeerMediaStatus,
  })(peer);
